<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Confirmación</h4>
  <button type="button" class="close btn-default btn-circle" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p [innerHTML]="message" class="p-1"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary w-100 me-2 shadow-none" (click)="this.activeModal.close(true)">{{acceptButtonText}}</button>
</div>
